import React from 'react';
import PegRewardCard from './PegRewardCard';
import uniqueId from 'lodash.uniqueid';
import { Text } from '@sitecore-jss/sitecore-jss-react';

var PegRewardCardList = function PegRewardCardList(props) {
  var userPegs = props.userPegs,
      model = props.model;
  var _model$rewardAmount = model.rewardAmount,
      rewardAmount = _model$rewardAmount === void 0 ? {} : _model$rewardAmount,
      _model$loyaltyCurrenc = model.loyaltyCurrency,
      loyaltyCurrency = _model$loyaltyCurrenc === void 0 ? {} : _model$loyaltyCurrenc,
      _model$pegRewardCard = model.pegRewardCard,
      pegRewardCard = _model$pegRewardCard === void 0 ? [] : _model$pegRewardCard;
  var pegRewardCardAux = pegRewardCard.filter(function (reward) {
    var _reward$fields, _reward$fields$Reward;

    var rewardAmountArr = (_reward$fields = reward.fields) === null || _reward$fields === void 0 ? void 0 : (_reward$fields$Reward = _reward$fields.RewardAmount) === null || _reward$fields$Reward === void 0 ? void 0 : _reward$fields$Reward.value.split(' ');

    if (parseInt(rewardAmount.value) === parseInt(rewardAmountArr[0])) {
      return true;
    } else {
      return false;
    }
  });
  var id = uniqueId();

  if (!pegRewardCardAux.length) {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "cb-peg-reward-card-list ".concat(parseInt(userPegs) < parseInt(rewardAmount.value) ? 'cb-peg-reward-card-list--inactive' : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: 'cb-peg-reward-card-list__reward-amount-container'
  }, /*#__PURE__*/React.createElement(Text, {
    tag: 'span',
    field: rewardAmount,
    className: 'cb-peg-reward-card-list__reward-amount'
  }), /*#__PURE__*/React.createElement(Text, {
    tag: 'span',
    field: loyaltyCurrency,
    className: 'cb-peg-reward-card-list__reward-amount-currency'
  })), /*#__PURE__*/React.createElement("div", {
    className: 'cb-peg-reward-card-list__reward-cards-container'
  }, pegRewardCardAux === null || pegRewardCardAux === void 0 ? void 0 : pegRewardCardAux.map(function (reward, index) {
    return /*#__PURE__*/React.createElement(PegRewardCard, {
      model: reward.fields,
      userPegs: userPegs,
      key: "reward-".concat(id, "-").concat(index)
    });
  })));
};

export default PegRewardCardList;